var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-summary"},[(_vm.basket)?_c('div',[(_vm.basket.original_total)?_c('span',[_vm._v("Order Subtotal: "),_c('strong',[_vm._v("£"+_vm._s(_vm._f("money")(_vm.basket.original_total)))])]):_c('span',[_vm._v("Order Subtotal: "),_c('strong',[_vm._v("£"+_vm._s(_vm._f("money")(_vm.basket.total)))])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }